export default __webpack_public_path__ + "static/media/description.3e91b018.svg";